const initFieldNumber = ($fieldNumber = $('.field-number')) => {
	const $input = $fieldNumber.find('.js-field-input')
	const $fieldNumberButton = $fieldNumber.find('.js-field-btn');
	const inputMin = $input.attr('min');
	const inputMax = $input.attr('max');

	$fieldNumberButton.on('click', function(event) {
		event.preventDefault();

		const $btn = $(this);
		let inputValue = parseInt($input.val(), 10) || 0;

		if ($btn.hasClass('js-field-decrement')) {
			if ( inputValue != inputMin) {
				inputValue --;
			}
		} else {
			if ( inputValue < inputMax) {
				inputValue++;
			}
		}

		$input.val(inputValue);
	});
};

initFieldNumber();

export default initFieldNumber;
